import DOMPurify from 'dompurify';

export enum FaqCategory {
    patientAlgemeen = 26,
    patientOsas = 40,
}

export type FaqPost = {
    answer: string;
    ID: number;
    question: string;
};

export type Faqs = {
    color: string;
    icon: string;
    ID: number;
    name: string;
    posts: FaqPost[];
    slug: string;
};

const KSYOS_WORDPRESS_API_ROOT = 'https://ksyos.nl/wp-json/ksyos/v1';

export async function getFaqs(faqCategory: FaqCategory): Promise<Faqs> {
    const response = await fetch(`${KSYOS_WORDPRESS_API_ROOT}/faqs?term_id=${faqCategory}`);
    const dirtyFaqs = await response.json();
    const cleanFaqs = {
        ...dirtyFaqs,
        posts: dirtyFaqs.posts.map((post: FaqPost) => ({
            ...post,
            answer: DOMPurify.sanitize(post.answer),
        })),
    };

    return cleanFaqs;
}
